import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["calendarRef", "compact", "onPopoverClose", "children", "hideWeekends", "events", "maxEventDisplayCount", "onOverflowButtonClick", "openPopover"];
import I18n from 'I18n';
import { MonthGrid, Header, OverflowButton, CompactHeader } from './MonthCalendarStyles';
import MonthCalendarGrid from './MonthCalendarGrid';
import { getCompactDayName, getDayName, getDayNameWithLocale, getWeekdaysRange } from '../../lib/time';
import DayOfWeek from '../DayOfWeek';
import { MonthOverflow } from '../../components/Overflow/Overflow';
import { CalendarViewShell } from '../../components/CalendarViewShell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const noop = () => {};
function renderCompactHeader(hideWeekends) {
  const days = getWeekdaysRange(hideWeekends, I18n.moment.locale()).map(dayOfWeek => {
    const weekDayKey = getDayNameWithLocale(dayOfWeek, 'en');
    return /*#__PURE__*/_jsx(DayOfWeek, {
      weekDayKey: weekDayKey,
      dayOfWeekNumber: dayOfWeek,
      children: getCompactDayName(dayOfWeek)
    }, dayOfWeek);
  });
  return /*#__PURE__*/_jsx(CompactHeader, {
    "data-test-id": "calendar-month-compact-header",
    children: days
  });
}
function renderHeader(hideWeekends) {
  const days = getWeekdaysRange(hideWeekends, I18n.moment.locale()).map((dayOfWeek, i) => {
    const weekDayKey = getDayNameWithLocale(dayOfWeek, 'en');
    return /*#__PURE__*/_jsx(DayOfWeek, {
      weekDayKey: weekDayKey,
      dayOfWeekNumber: i,
      children: getDayName(dayOfWeek)
    }, dayOfWeek);
  });
  return /*#__PURE__*/_jsx(Header, {
    "data-test-id": "calendar-month-header",
    children: days
  });
}
export default function MonthCalendarView(_ref) {
  let {
      calendarRef,
      compact,
      onPopoverClose = noop,
      hideWeekends,
      events,
      maxEventDisplayCount = 0,
      onOverflowButtonClick = noop,
      openPopover
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CalendarViewShell, {
    "data-test-id": "calendar-container--MONTH",
    calendarRef: calendarRef,
    children: [compact ? renderCompactHeader(hideWeekends) : renderHeader(hideWeekends), /*#__PURE__*/_jsx(MonthGrid, {
      children: /*#__PURE__*/_jsx(MonthCalendarGrid, Object.assign({}, rest, {
        compact: compact,
        hideWeekends: hideWeekends,
        events: events,
        maxEventDisplayCount: maxEventDisplayCount,
        renderOverflow: ({
          week,
          dayOfWeek,
          dayIndex,
          actualDate
        }) => /*#__PURE__*/_jsx(MonthOverflow, {
          actualDate: actualDate,
          dayOfWeek: dayOfWeek,
          dayIndex: dayIndex,
          week: week,
          buttonAs: OverflowButton,
          displayDay: rest.displayDay,
          displayMonth: rest.displayMonth,
          displayYear: rest.displayYear,
          hideWeekends: hideWeekends,
          useExactEventTimes: rest.useExactEventTimes,
          renderOverflowEvents: rest.renderOverflowEvents,
          events: events,
          onOverflowButtonClick: onOverflowButtonClick,
          openPopover: openPopover || undefined,
          onPopoverClose: onPopoverClose
        })
      }))
    })]
  });
}